import { render, staticRenderFns } from "./OrderEvent.vue?vue&type=template&id=5b765c2e&scoped=true"
import script from "./OrderEvent.vue?vue&type=script&lang=js"
export * from "./OrderEvent.vue?vue&type=script&lang=js"
import style0 from "./OrderEvent.vue?vue&type=style&index=0&id=5b765c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b765c2e",
  null
  
)

export default component.exports